import anime from "animejs";

const statSection = document.querySelector(".v_stats__numbers_grid");

if (statSection) {
  let done; // boolean to check if animation is done
  let responsiveDelay = 400; // delay for responsive
  let responsiveDelayLonger = 400; // delay for responsive
  let responsiveBreakpoint = 980; // breakpoint for responsive

  // wrapping into scroll effect
  // options for scroll observer
  let rootMarginvalue = "-10px 0px 0px";
  // media query
  if (window.innerWidth < responsiveBreakpoint) {
    rootMarginvalue = "-10px 0px 0px 0px";
    responsiveDelay = 1000;
    responsiveDelayLonger = 1400;
  }

  const observerOptions = {
    rootMargin: rootMarginvalue,
  };

  // defining observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !done) {
        // callback animation
        animatingNumbers();
        done = true;
      } else {
      }
    });
  }, observerOptions);

  // calling observer
  observer.observe(statSection);

  // get HTML elements for numbers + values
  const number1 = document.querySelector("#animatedNumber1");
  const number2 = document.querySelector("#animatedNumber2");
  const number3 = document.querySelector("#animatedNumber3");
  const numbers = [number1, number2, number3];
  initiateValues(numbers)
  const amountCollected = number1.dataset.amountCollected;
  const amountFunds = number2.dataset.amountFunds;
  const amountPartners = number3.dataset.amountPartners;


  function initiateValues(numbers) {
    // initiate values
    numbers.forEach((number) => {
      number.style.opacity = 0;
    });
  }

  // animating numbers
  function animatingNumbers() {
    // variables definition
    const blurValue = "blur(3px)";
    const opacityValue = 0.2;

    // initialization styling for numbers
    numbers.forEach((number) => {
      number.style.filter = blurValue;
      number.style.opacity = opacityValue;
    });

    // animate numbers
    const millions = anime({
      targets: "#animatedNumber1",
      innerHTML: ["001", amountCollected],
      easing: "cubicBezier(.81,.15,0.2,1)",
      duration: 3000,
      // delay: 1000,
      round: 1,
      update: function (anim) {
        const progress = anim.progress;
        const blurAmount = 3 - Math.round((progress * 3) / 100);
        const opacityAmount = opacityValue + progress / 100;
        number1.style.filter = "blur(" + blurAmount + "px)";
        number1.style.opacity = opacityAmount;
      },
      complete: function (anim) {
        number1.style.filter = "blur(0px)";
      }
    });

    const funds = anime({
      targets: "#animatedNumber2",
      innerHTML: [1, amountFunds],
      easing: "cubicBezier(.2,.15,0.2,1)",
      duration: 3200,
      delay: 500 + responsiveDelay,
      round: 1,
      update: function (anim) {
        const progress = anim.progress;
        const blurAmount = 3 - Math.round((progress * 3) / 100)
        const opacityAmount = opacityValue + progress / 100;
        number2.style.filter = "blur(" + blurAmount + "px)";
        number2.style.opacity = opacityAmount;
      },
      complete: function (anim) {
        number2.style.filter = "blur(0px)";
      }
    });

    const partners = anime({
      targets: "#animatedNumber3",
      innerHTML: [1, amountPartners],
      easing: "cubicBezier(.81,.15,0.2,1)",
      duration: 3300,
      delay: 800 + responsiveDelayLonger,
      round: 1,
      update: function (anim) {
        const progress = anim.progress;
        const blurAmount = 3 - Math.round((progress * 3) / 100);
        const opacityAmount = opacityValue + progress / 100;
        number3.style.filter = "blur(" + blurAmount + "px)";
        number3.style.opacity = opacityAmount;
      },
      complete: function (anim) {
        number3.style.filter = "blur(0px)";
      }
    });

    // grabd html elements for texts
    const opacityAnimatedTop = document.querySelector("#opacityAnimated4");
    const opacityAnimatedBottomFirst =
      document.querySelector("#opacityAnimated1");
    const opacityAnimatedBottomSecond =
      document.querySelector("#opacityAnimated2");
    const opacityAnimatedBottomThird =
      document.querySelector("#opacityAnimated3");

    // animate text opacity
    anime({
      targets: opacityAnimatedTop,
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 1000,
      delay: 1400,
    });
    anime({
      targets: opacityAnimatedBottomFirst,
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 800,
      delay: 1400,
    });
    anime({
      targets: opacityAnimatedBottomSecond,
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 1000,
      delay: 1700 + responsiveDelay,
    });
    anime({
      targets: opacityAnimatedBottomThird,
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 1200,
      delay: 2200 + responsiveDelayLonger,
    });
  }
}
